angular
	.module('domain.activity', [
		'ngRoute',
		'upResources',
		'security.authorization',
		'services.customer',
		'services.templateCacher'
	])
	.config([
		'$stateProvider',
		'$routeGuardProvider',
		'$httpProvider',
		'$upModalProvider',
		function ($stateProvider, $routeGuardProvider, $httpProvider, $upModalProvider) {
			// Empty shell for the React /activities route — keeps the URL claimed and the
			// $state.go('activities') callers working; React renders the list.
			$stateProvider.state('activities', {
				url: '/:customerId/activities/',
				template: '<div></div>',
				section: 'sale',
				resolve: {
					authUser: [
						'$routeGuard',
						function ($routeGuard) {
							return $routeGuard.requireUser();
						}
					]
				}
			});

			$upModalProvider.modal('editActivity', {
				// Hand every caller to the React modal once REACT_EDIT_ACTIVITY is on
				// (WEB-10153). Everything below stays the flag-off path until the
				// Angular modal is retired on WEB-8899.
				forwardToReactModal: 'EditActivity',
				templateUrl: require('App/upsales/domain/activity/views/editActivity.html?file'),
				style: 'form default dynamic initially-hidden',
				controller: 'EditActivity as EditActivity',
				invisibleCurtain: true,
				rememberHeight: true,
				resolve: {
					meta: function ($modalParams, EditActivityMeta) {
						return EditActivityMeta($modalParams);
					}
				}
			});
		}
	]);
